import React, { forwardRef } from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { SimpleIcon } from './icon-utils';

export const BellIcon = forwardRef(function BellIcon(
  props: SimpleIconInterface,
  ref: React.Ref<SVGSVGElement>
): JSX.Element {
  const { fill = '#FFFFFF', ...rest } = props;

  return (
    <SimpleIcon ref={ref} viewBoxDimensions="0 0 24 24" {...rest}>
      <path
        d="M10.2673 21C10.4428 21.304 10.6953 21.5565 10.9993 21.732C11.3033 21.9075 11.6482 21.9999 11.9993 21.9999C12.3503 21.9999 12.6952 21.9075 12.9992 21.732C13.3033 21.5565 13.5557 21.304 13.7313 21M3.26127 15.326C3.13063 15.4692 3.04442 15.6472 3.01312 15.8385C2.98183 16.0298 3.00679 16.226 3.08498 16.4034C3.16316 16.5807 3.2912 16.7316 3.45352 16.8375C3.61585 16.9434 3.80545 16.9999 3.99927 17H19.9993C20.1931 17.0001 20.3827 16.9438 20.5451 16.8381C20.7076 16.7324 20.8358 16.5817 20.9142 16.4045C20.9926 16.2273 21.0178 16.0311 20.9867 15.8398C20.9557 15.6485 20.8697 15.4703 20.7393 15.327C19.4093 13.956 17.9993 12.499 17.9993 8C17.9993 6.4087 17.3671 4.88258 16.2419 3.75736C15.1167 2.63214 13.5906 2 11.9993 2C10.408 2 8.88185 2.63214 7.75663 3.75736C6.63141 4.88258 5.99927 6.4087 5.99927 8C5.99927 12.499 4.58827 13.956 3.26127 15.326Z"
        fill="none"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeOpacity="0.8"
        strokeWidth="2"
      />
    </SimpleIcon>
  );
});
